import { render, staticRenderFns } from "./ModalCasoAvaliacao.vue?vue&type=template&id=482a647a&scoped=true&"
import script from "./ModalCasoAvaliacao.vue?vue&type=script&lang=js&"
export * from "./ModalCasoAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a647a",
  null
  
)

export default component.exports